import { Location } from "react-router-dom";

export const isDepragAmbergDependent = (location: Location) => {
    return location.pathname.includes("videoCourses");
}